import MatchDataCollector from "./_components/live/matchdatacollector";
import MatchStatusLoader from "./_components/live/matchstatusloader";
import MatchDataModuleUpdater from "./_components/live/matchdata-modules-updater";
import MatchHeader from "./_modules/sportdata/volley/match-header";
import MatchStatsByPlayer from "./_modules/sportdata/volley/match-player-stats";
import CourtGraphic from "./_modules/sportdata/volley/court-graphic";
import matchList from "./_modules/sportdata/volley/match-list";
import EditorialLiveUpdate from "./_modules/sportdata/volley/editorial-live-update";

window.matchStatusLoader = new MatchStatusLoader();
window.matchDataCollector = new MatchDataCollector();
window.matchDataModuleUpdater = new MatchDataModuleUpdater();
window.editorialLiveUpdate = new EditorialLiveUpdate();
window.matchHeader = new MatchHeader();
window.CourtGraphic = new CourtGraphic();
window.matchList = new matchList();
window.matchStatsByPlayer = new MatchStatsByPlayer();

export default class Live {
  constructor() {
    this.init();
  }

  init() {
    //
  }
}
